module.exports = __webpack_public_path__ + "static/media/v2.cdf1add0.JPG";